export default __webpack_public_path__ + "static/media/repeat.e38874f5.svg";